/**
 * Builds a versioned asset URL for local static assets.
 */
export const assetUrl = (assetPath: string) => {
  if (assetPath.startsWith('http')) return assetPath;

  if (assetPath.startsWith('/')) {
    assetPath = assetPath.slice(1);
  }

  assetPath = `/assets/${assetPath}`;
  if (location.hostname === 'localhost') {
    return assetPath;
  }

  return `/${__APP_VERSION__}${assetPath}`;
};
